import React, { useEffect, useState } from "react"
import { APPOINTMENTS } from "../../../../../library/store/actions/types/calendarTypes"
import { call } from "../../../../../library/networking/API"
import { Route, useHistory, useLocation, useRouteMatch } from "react-router-dom"
import { useAlert } from "../../../../../hooks/useAlert"
import { useDispatch, useSelector } from "react-redux"
import {
  acceptMeet,
  declineMeet,
  incomingMeetsList,
} from "../../../../../library/store/actions/creators/uknowCreators"
import Stub from "../../../../../components/stub"
import { SearchOutlined } from "@material-ui/icons"
import Table, {
  recordsPerPageOptions,
} from "../../../../../components/v2/table/table"
import { TablePagination, Tooltip } from "@material-ui/core"
import UpdateIcon from "@material-ui/icons/UpdateOutlined"
import CheckOutlined from "@material-ui/icons/CheckOutlined"
import CloseOutlined from "@material-ui/icons/CloseOutlined"
import {
  KNOWMAP_INCOMING_KNOWMEET,
  KNOWMAP_INCOMING_MEET,
  KNOWMAP_INCOMING_MEETS,
} from "../../../../../library/constants/routes"
import MeetDialog from "../meets/MeetDialog"
import * as qs from "query-string"
import composeQuery from "../../../../../library/utils/composeQuery"
import styled from "@emotion/styled"
import { colors } from "../../../../../library/constants/styles/colors"
import {
  acceptAppointmentBooking,
  cancelAppointmentBooking,
  declineAppointmentBooking,
  getIncomingAppointmentBookings,
} from "../../../../../library/store/actions/creators/knowmapCreators"
import AppointmentBookingDialog from "./appointmentBookingDialog"

const columns = [
  { id: 1, label: "Name" },
  { id: 2, label: "Inviter" },
  { id: 3, label: "Starts at" },
  { id: 4, label: "Duration" },
  { id: 5, label: "Link/Phone" },
  { id: 6, label: "Details" },
]

const Container = styled.div`
  padding: 15px 10px;
  box-shadow: 0 0 2px 0 ${colors.black12};
  background-color: ${colors.white};
  border-radius: 2px;
`

const IncomingBookings = () => {
  const history = useHistory()
  const location = useLocation()
  const { path } = useRouteMatch()

  const { successAlert, errorAlert } = useAlert()

  const dispatch = useDispatch()
  const { incomingBookings } = useSelector(({ knowmap }) => knowmap)

  const [name, setName] = useState("")
  const [page, setPage] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(recordsPerPageOptions[0])

  const [dataReceived, setDataReceived] = useState(false)
  const [changingPage, setChangingPage] = useState(false)
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)
  const [selectedRecordId, setSelectedRecordId] = useState(null)

  const getRecords = async ({ name, offset, limit } = {}) => {
    await dispatch(getIncomingAppointmentBookings({ name, offset, limit }))
  }

  const fetchData = async (offset = 0, shouldPageChange = false) => {
    const { q } = qs.parse(location.search)
    if (shouldPageChange) setChangingPage(true)

    await getRecords({
      name: q || undefined,
      offset,
      limit: recordsPerPage,
    })

    setDataReceived(true)
    if (shouldPageChange) setChangingPage(false)
  }

  // React.useEffect(async () => {
  //   const response = await call(APPOINTMENTS.LIST, { offset: 0, limit: 10 })
  //   const json = await response.data
  //   console.log(json)
  // }, [])

  React.useEffect(() => {
    const { q } = qs.parse(location.search)

    if (typeof q === "string") {
      setName(q)
    }

    fetchData()
  }, [])

  const onAccept = async ({ id }) => {
    try {
      await dispatch(acceptAppointmentBooking({ id }))
      successAlert("Booking accepted")
    } catch (e) {
      errorAlert(e)
    }
  }

  const onDecline = async ({ id }) => {
    try {
      await dispatch(declineAppointmentBooking({ id }))
      successAlert("Booking declined")
    } catch (e) {
      errorAlert(e)
    }
  }

  const _composeQuery = () => {
    composeQuery({
      fields: {
        q: name || undefined,
      },
      history,
      path,
    })
  }

  const onSearch = (event) => {
    event.preventDefault()

    _composeQuery()
  }

  useEffect(() => {
    if (dataReceived) {
      fetchData()
      setPage(0)
    }
  }, [location.search])

  const onInfoOpen = (id) => {
    setSelectedRecordId(id)
    setIsDetailsOpen(true)
  }

  const onInfoClose = () => {
    setIsDetailsOpen(false)
    setSelectedRecordId(null)
  }

  return (
    <div className="box">
      <div className="box__heading">Incoming Appointment Bookings</div>

      {dataReceived && !!incomingBookings.list.length && (
        <Container>
          {/*<div className="mb15">*/}
          {/*  <div className="search-form search-form--compact">*/}
          {/*    <div className="search-form__icon">*/}
          {/*      <SearchOutlined />*/}
          {/*    </div>*/}
          {/*    <form onSubmit={onSearch}>*/}
          {/*      <input*/}
          {/*        type="text"*/}
          {/*        id="search"*/}
          {/*        name="search"*/}
          {/*        placeholder="Search Meets"*/}
          {/*        className="search-form__field"*/}
          {/*        autoComplete="off"*/}
          {/*        value={name}*/}
          {/*        onChange={(e) => setName(e.target.value)}*/}
          {/*      />*/}
          {/*    </form>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <Table
            columns={columns}
            data={incomingBookings.list}
            fluid={columns.length <= 5}
            changingPage={changingPage}
            onDetailsOpen={(record) => {
              onInfoOpen(record.raw.id, "confirmable")
            }}
            actions={(record) =>
              [
                !record.accepted &&
                  !record.declined && {
                    component: () => (
                      <Tooltip title="Accept" arrow key={"Accept booking"}>
                        <CheckOutlined
                          onClick={() => onAccept({ id: record.id })}
                        />
                      </Tooltip>
                    ),
                  },
                !record.accepted &&
                  !record.declined && {
                    component: () => (
                      <Tooltip title="Decline" arrow key={"Decline booking"}>
                        <CloseOutlined
                          onClick={() => onDecline({ id: record.id })}
                        />
                      </Tooltip>
                    ),
                  },
              ].filter(Boolean)
            }
          />
          <TablePagination
            count={100}
            page={page}
            onPageChange={(e, value) => setPage(value)}
            rowsPerPage={recordsPerPage}
            rowsPerPageOptions={recordsPerPageOptions}
            onRowsPerPageChange={(e) =>
              setRecordsPerPage(parseInt(e.target.value, 10))
            }
          />
        </Container>
      )}
      {dataReceived && !incomingBookings.list.length && (
        <Stub text={"You don't have incoming bookings yet"} />
      )}

      {isDetailsOpen && (
        <AppointmentBookingDialog
          isConfirmable={true}
          onClose={onInfoClose}
          open={isDetailsOpen}
          activeBookingId={selectedRecordId}
        />
      )}
    </div>
  )
}

export default IncomingBookings
